// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1kXO9","footer":"ModalUpdate_footer__21pbv"};